module.exports = require("d3-format");


/*****************
 ** WEBPACK FOOTER
 ** external "d3-format"
 ** module id = 20
 ** module chunks = 0 1
 **/